<template>
  <div>
    <form @submit.prevent="handleFormSubmit" class="form">
      <div v-if="check === 1" class="row center-xs">
        <spinner></spinner>
      </div>
      <div style="color: white; font-size: 24px;" v-else-if="check === 2">
        {{ error }}
        <router-link
          :to="{ name: 'auth-login' }"
          class="button form__button"
          tag="button"
          >Войти</router-link
        >
      </div>
      <div v-else>
        <p style="color:white;text-align: center; font-size: 28px;">
          <strong> {{ user_data.firstname }} {{ user_data.patronym }} </strong>
        </p>
        <p style="color:white;text-align: center; font-size: 17px;">
          Ваш логин:
          {{ user_data.username }}
        </p>

        <br />
        <p style="color:white;text-align: center">Придумайте пароль</p>
        <br />
        <!--------------------------------------------------------   LEI SERIES   ----->
        <register-input
          v-model="newpass"
          componentID="lei"
          inputType="password"
          label="Пароль"
          inputPlaceholder="Пароль"
          :isRequired="true"
          class="form__input"
        />
        <!--------------------------------------------------------  giin  SERIES   ----->
        <register-input
          v-model="repeat_newpass"
          componentID="giin"
          inputType="password"
          label="Повторите пароль"
          inputPlaceholder="Повторите пароль"
          :isRequired="true"
          class="form__input"
        />
        <p class="login-form__error" v-show="error">
          {{ error }}
        </p>
        <button class="button filled form__button">Подтвердить</button>
      </div>
    </form>
  </div>
</template>

<script>
import regFormMixin from "../form_mixin";
import { FhsAxios } from "../../../services/axios";

export default {
  props: ["user_profile"],
  name: "MainRegForm",
  data() {
    return {
      user_data: null,
      error: false,
      newpass: "",
      repeat_newpass: "",
      check: 1, // 0 - setting password , 1 - loading , 2 - error
      token: this.$route.params.code
    };
  },
  mixins: [regFormMixin],
  watch: {},
  methods: {
    fetchForm() {
      try {
        this.token = this.$route.params.code;
      } catch (e) {
        // ERROR HANDLER
      }
    },
    saveData() {
      let url = `user/reset-password`;
      const form = {
        token: this.token,
        newpass: this.newpass,
        check: this.check
      };
      FhsAxios.post(url, form).then(res => {
        this.error = false;
        switch (this.check) {
          case 0: // Saving New Password
            if (res.data.status) {
              this.$toasted.success("Ваш пароль установлен");
              setTimeout(() => {
                this.$toasted.show("Введите логин и пароль");
              }, 1000);
              this.$router.push({ name: "auth-login" });
              break;
            } else {
              this.error = res.data.statusmsg.error;
              this.$toasted.error("Произошла ошибка");
            }
            break;
          case 1: // Checking TOKEN if is available
            if (res.data.status) {
              this.user_data = res.data.result;
              this.check = 0;
              break;
            } else {
              setTimeout(() => {
                this.$toasted.error(res.data.statusmsg);
                this.$router.push({ name: "auth-login" });
              }, 1000);
            }
            break;
        }
      });
    },
    handleFormSubmit() {
      if (this.newpass !== this.repeat_newpass) {
        this.$toasted.show("Пароли не совпадают");
        return;
      }
      this.saveData();
    }
  },
  beforeMount() {
    this.$emit("loading-status", true);
    this.saveData();
    this.fetchForm();
  }
};
</script>

<style>
.login-form__error {
  margin-top: 20px;
  color: #ef4748;
}
</style>
